import React from 'react';

/**
 * LocationTags — simple tag list block with an "Add Tags" action.
 *
 * Usage:
 *   <LocationTags
 *     tags={['Baroque', 'Palace', 'Fountains']}
 *   />
 */
const LocationTags = ({ tags = [], onEditTag }: any) => (
    <div className="lt-card">
        <div className="lt-card__header">
            <h3 className="lt-card__title">Location Tags</h3>
            <button className="lt-add-btn" onClick={onEditTag}>Edit Tags</button>
        </div>

        {tags?.length > 0 && (
            <div className="lt-tags">
                {tags.map((tag: any, i: number) => (
                    <span className="lt-tag" key={i}>{tag}</span>
                ))}
            </div>
        )}
    </div>
);

export default LocationTags;